// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form_create-role-form__-fYco .Form_mapped-profile__2S3Xl {
  margin-top: 3px;
  display: flex;
  padding: 10px 15px;
  justify-content: space-between;
  background: white;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
}
.Form_create-role-form__-fYco .Form_mapped-profile__2S3Xl .Form_profile-summary__1UYp1 {
  display: flex;
}
.Form_create-role-form__-fYco .Form_mapped-profile__2S3Xl .Form_profile-summary__1UYp1 .Form_profile-img__EF7Ns img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}
.Form_create-role-form__-fYco .Form_mapped-profile__2S3Xl .Form_profile-summary__1UYp1 .Form_profile-info__nLt4J {
  margin-left: 10px;
  color: #6f6f6f;
}
.Form_create-role-form__-fYco .Form_mapped-profile__2S3Xl .Form_profile-summary__1UYp1 .Form_profile-info__nLt4J .Form_profile-name__t5NKZ {
  color: black;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px !important;
}
.Form_create-role-form__-fYco .Form_mapped-profile__2S3Xl .Form_delete-mapped-profile__cjgsl {
  cursor: pointer;
}
.Form_create-role-form__-fYco .Form_create-button__ItC7V {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px;
}
.Form_create-role-form__-fYco .Form_permissions__UHUhu {
  margin-left: 20px;
}
.Form_create-role-form__-fYco .Form_permissions__UHUhu .Form_sub-permissions__AF48S {
  margin-bottom: 15px;
}
.Form_create-role-form__-fYco .Form_permissions__UHUhu .Form_sub-permissions__AF48S .Form_title__k2XkC {
  margin-bottom: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/RoleCreate/Components/Form/Form.module.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;AACI;EACE,aAAA;AACN;AACQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AACV;AAEM;EACE,iBAAA;EACA,cAAA;AAAR;AACQ;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;AACV;AAGI;EACE,eAAA;AADN;AAIE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;AAFJ;AAKE;EACE,iBAAA;AAHJ;AAII;EACE,mBAAA;AAFN;AAGM;EACE,6BAAA;AADR","sourcesContent":[".create-role-form {\n  .mapped-profile {\n    margin-top: 3px;\n    display: flex;\n    padding: 10px 15px;\n    justify-content: space-between;\n    background: white;\n    border-radius: 5px;\n    border: 1px solid #d9d9d9;\n    .profile-summary {\n      display: flex;\n      .profile-img {\n        img {\n          width: 80px;\n          height: 80px;\n          border-radius: 10px;\n          object-fit: cover;\n        }\n      }\n      .profile-info {\n        margin-left: 10px;\n        color: #6f6f6f;\n        .profile-name {\n          color: black;\n          font-weight: 600;\n          font-size: 16px;\n          margin-bottom: 10px !important;\n        }\n      }\n    }\n    .delete-mapped-profile {\n      cursor: pointer;\n    }\n  }\n  .create-button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    padding: 30px;\n  }\n\n  .permissions {\n    margin-left: 20px;\n    .sub-permissions {\n      margin-bottom: 15px;\n      .title {\n        margin-bottom: 5px !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"create-role-form": `Form_create-role-form__-fYco`,
	"mapped-profile": `Form_mapped-profile__2S3Xl`,
	"profile-summary": `Form_profile-summary__1UYp1`,
	"profile-img": `Form_profile-img__EF7Ns`,
	"profile-info": `Form_profile-info__nLt4J`,
	"profile-name": `Form_profile-name__t5NKZ`,
	"delete-mapped-profile": `Form_delete-mapped-profile__cjgsl`,
	"create-button": `Form_create-button__ItC7V`,
	"permissions": `Form_permissions__UHUhu`,
	"sub-permissions": `Form_sub-permissions__AF48S`,
	"title": `Form_title__k2XkC`
};
export default ___CSS_LOADER_EXPORT___;
